import { Text, Badge, Box } from '@chakra-ui/react';
import DataTableCard from './DataTableCard';
import { useBinderCardColors } from '../hooks/useBinderCardColors';
import { formatSimpleValue } from '../utils/fieldFormatting';
import ValidationBadge from './ValidationBadge';

interface BusinessUseCardProps {
  data?: any;
}

const BusinessUseCard = ({ data }: BusinessUseCardProps) => {
  const colors = useBinderCardColors();

  // Get processed vehicles data
  const vehicles = data?.vehicles || [];

  const formatBusinessPercentage = (percentage: any) => {
    // Convert to number if it's a string
    const numValue =
      typeof percentage === 'string' ? parseFloat(percentage) : percentage;

    if (isNaN(numValue) || numValue === null || numValue === undefined) {
      return (
        <Badge colorScheme="gray" variant="outline" fontSize="xs">
          Not specified
        </Badge>
      );
    }

    return (
      <Text color={colors.valueColor} fontSize="sm" fontWeight="medium">
        {numValue}%
      </Text>
    );
  };

  // Create table rows from processed vehicle data
  const vehicleRows = vehicles.map((vehicle: any) => {
    return [
      vehicle.name,
      formatBusinessPercentage(vehicle.businessPercentage),
      vehicle.remarks ? (
        <Text fontSize="sm">{formatSimpleValue(vehicle.remarks)}</Text>
      ) : (
        <Text fontSize="xs" color="gray.500" fontStyle="italic">
          No remarks
        </Text>
      ),
      <ValidationBadge status={vehicle.isValid ? 'pass' : 'caution'} />,
    ];
  });

  const headers = ['Vehicle', 'Business Use %', 'Remarks', 'Outcome'];

  // Handle empty state
  if (vehicleRows.length === 0) {
    return (
      <Box p={4} borderRadius="md" bg={colors.emptyFieldBgColor}>
        <Text color="gray.500" fontStyle="italic" textAlign="center">
          No vehicle data available
        </Text>
      </Box>
    );
  }

  return (
    <DataTableCard
      description="Track percentage of business usage for each vehicle."
      headers={headers}
      rows={vehicleRows}
    />
  );
};

export default BusinessUseCard;
